document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.custom-elements-container');
  if (!container) return;

  // Convert grid3 elements
  container.querySelectorAll('grid3').forEach(grid => {
    const isReverse = grid.getAttribute('reverse') === 'true';
    const wrapper = document.createElement('div');
    wrapper.className = `custom-grid ${isReverse ? 'custom-grid--reverse' : ''}`;
    grid.parentNode.insertBefore(wrapper, grid);
    wrapper.appendChild(grid.cloneNode(true));
    grid.remove();
  });

  // Convert griditem4 and griditem5 elements
  container.querySelectorAll('griditem4, griditem5').forEach(item => {
    const div = document.createElement('div');
    div.className = item.tagName.toLowerCase() === 'griditem4' ? 'custom-grid__item-4' : 'custom-grid__item-5';
    item.parentNode.insertBefore(div, item);
    div.appendChild(item.cloneNode(true));
    item.remove();
  });

  // Convert border elements
  container.querySelectorAll('border').forEach(border => {
    const isWhite = border.getAttribute('white') === 'true';
    const thickness = border.getAttribute('thickness') || '1';
    const rotate = border.getAttribute('rotate') || '0';
    const wideShadow = border.getAttribute('wideshadow') === 'true';

    const wrapper = document.createElement('div');
    wrapper.className = `custom-border ${isWhite ? 'custom-border--white' : ''} ${wideShadow ? 'custom-border--wide-shadow' : ''}`;
    wrapper.style.setProperty('--border-thickness', `${thickness}px`);
    wrapper.style.setProperty('--rotate-angle', `${rotate}deg`);

    border.parentNode.insertBefore(wrapper, border);
    wrapper.appendChild(border.cloneNode(true));
    border.remove();
  });
}); 